import { useState } from "react";
import PostForm from "../components/PostForm";
import Ticket from "../components/Ticket";

export default function Pos() {
  const [saleResult, setSaleResult] = useState(null);

  return (
    <>
      {/* Formulario del POS */}
      <div className="container">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Punto de Venta</h2>
          </div>
          
          <div className="card-body">
            <PostForm onSuccess={(data) => setSaleResult(data)} />
          </div>
        </div>
      </div>

      {/* Ticket FUERA del container para que se imprima correctamente */}
      {saleResult && (
        <Ticket
          invoice={saleResult}
          onAfterPrint={() => setSaleResult(null)}
        />
      )}
    </>
  );
}